import { noop } from '@reatom/framework'
import { useState } from 'react'
import styled from 'styled-components'

import { CommentMessage } from '@root/entities/comment/ui'

import type { ClassNameProps } from '@root/shared/react'

type SupportConversationMessageProps = {
  isLoading: boolean
  imageAttachment?: string
  onMessageSend: (text: string) => void
  onImageAttachedChange?: (image: string | undefined) => void
} & ClassNameProps

export const SupportConversationMessage = ({
  isLoading,
  onMessageSend,
  imageAttachment,
  onImageAttachedChange,
  className,
}: SupportConversationMessageProps) => {
  const [text, setText] = useState<string>('')

  return (
    <Root className={className}>
      <CommentMessage
        isLoading={isLoading}
        text={text}
        imageAttached={imageAttachment}
        onChange={(value) => setText(value)}
        onMessageSend={onMessageSend}
        onClose={noop}
        onImageAttachedChange={onImageAttachedChange}
      />
    </Root>
  )
}

const Root = styled.div`
  padding: 4px;
`
